import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merges tailwindCSS classes
 *
 * ***Important: Use this function to set dynamic CSS classes of your component so that tailwindCSS is recognizing them - [see for more information](https://tailwindcss.com/docs/content-configuration#dynamic-class-names)***
 *
 * CN - Naming because of shadcn usage | Easier to use components from shadcn within this project
 *
 * @see https://ui.shadcn.com/
 * @see https://github.com/lukeed/clsx#readme
 * @see https://tailwindcss.com/docs/content-configuration#dynamic-class-names
 *
 * @param {ClassValue[]} inputs
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(
    clsx(
      inputs.map((input: ClassValue) =>
        input?.toString()?.replace('undefined', ''),
      ),
    ),
  )
}
